import { placementSettings } from './WarpSelector/placementSettings';
import { checkerboardCombination } from '@/components/CustomCheckerboard/MainViews/SizeSelector/combinations';
import canvasUtils from '@/plugins/canvas/CanvasUtils';

export default {
  data() {
    return  {
      canvasConfig: null
    }
  },
  inject: ['wrapImage'],
  methods: {
    decodeBase64(path) {
      const parts = path ? path.split(';base64,') : this.wrapImage().src.split(';base64,');
      const decodedData = atob(parts.pop());
      let decodedDataLength = decodedData.length;
      const type = parts[0].split('/').pop();
      const uInt8Array = new Uint8Array(decodedDataLength);

      while (decodedDataLength--) {
        uInt8Array[decodedDataLength] = decodedData.charCodeAt(decodedDataLength);
      }

      return new File([uInt8Array], `image.${ type }`, { type });
    },

    async uploadGeneratedImage(path) {
      const imageFile = await canvasUtils.getBlobFromUrl(this.wrapImage().src);
      return new Promise(resolve => {
        this.$store.dispatch("customCheckerboard/UPLOAD", {
          inputFile: imageFile,
          type: 'customcheckerboard',
        }).then(({ temp_image_id: id, ugc_image_path: url }) => {
          const uploadedImage = { id, url };
          this.$store.commit("customCheckerboard/SET_UPLOADED_IMAGE_DATA", uploadedImage);
          resolve(uploadedImage);
        });
      });
    },

    generatePlacementAndUgcSwatch(croppedImageDataUrl, componentName, size) {
      return new Promise(resolve => {
        this.$store.dispatch('customCheckerboard/GET_UGC_SWATCH', {
          model: this.model,
          imageBuffer: croppedImageDataUrl,
          checkerboardCombination: checkerboardCombination,
          componentName,
          size,
        }).then(({ ugcTemp }) => {
          resolve(ugcTemp);
        });
      });
    },

    updateTempRecipe(activeUGCComponent, ugcTemp, originalRecipe, warpId, swatchId) {
      // resets the temp recipe
      this.$store.commit("ugc/tempData/CLEAR");
      this.$store.commit('ugc/tempData/SET_RECIPE', originalRecipe)
      // adds the image the checkerboard to the temp recipe (tempData = true)
      this.$recipe.addToolkitOptions(activeUGCComponent, warpId, swatchId, true );
      this.$recipe.updateUGC(activeUGCComponent, ugcTemp, 'custom-checkerboard', true);
    },

    loadAndCropGeneratedImage(model, component, warp) {
      return new Promise(resolve => {
        const croppedImage = new Image();
        croppedImage.setAttribute('crossorigin', 'anonymous');
        croppedImage.src = this.wrapImage().src;
        croppedImage.onload = () => {
          const { x, y, width, height } = placementSettings[model][component][warp];
          const canvas = canvasUtils.createCanvasElement({ width, height });
          canvas.getContext('2d').drawImage(
            croppedImage, // Image to crop
            x, y, // Start position to crop
            width, height, // End position to crop
            0, 0, // Start position to paint in canvas
            width, height // End position to paint in canvas
          );

          canvasUtils.getBlobFromCanvas(canvas)
            .then(blob => {
              return canvasUtils.convertBlobToBase64(blob);
            })
            .then(url => {
              resolve(url);
            });
        };
      });
    },

  },
  created() {
    this.canvasConfig = this.$store.state.customCheckerboard.canvasConfig;
  },
}
